scrollLoad = function(){setTimeout( function(){
  jdgm.customizeBadges();
}, 100);}

document.addEventListener("scroll", scrollLoad);

window.addEventListener("load",function(){
  console.log("after loading flkty");
  let pdp_slider = document.querySelector(".product-slideshow");
  if(pdp_slider){
    var flkty = new Flickity(pdp_slider);
    flkty.resize();
  }
  if(reviewWidget) {
    reviewWidgetComments();
    document.querySelectorAll(".R-PaginationControls__item").forEach(function (element) {
      element.addEventListener('click', function () {
        console.log("click on page");
        reviewWidgetComments();
      });
    });
  }
});

function reviewWidgetComments() {
  setTimeout(() => {
    document.querySelectorAll(".R-ContentList__item").forEach(function (element2) {
      element2.closest(".R-ContentList__item").style.display = "flex";
    });
    document.querySelectorAll(".ElementsWidget-prefix .R-TextBody--xs *").forEach(function (element2) {
      console.log("element2.innerText:",element2.innerText);
      if(element2.innerText == "Kunde hat keine Kommentare hinterlassen."){
        element2.style.display = "none";
        element2.closest(".R-ContentList__item").style.display = "none";
      }
    });
  }, 500);
}

document.addEventListener("variant:change", function(event) {
  var variant = event.detail.variant;
  if(!variant || variant == null){
    return;
  }
  let money_datalayer_format = theme.settings.moneyFormat.replace('_with_comma_separator','').replace('CHF ','');
  let variant_price = theme.Currency.formatMoney(variant.price, money_datalayer_format);
  gtag('event','view_item', {
    'value': variant_price,
    'items': [
      {
        'id': "shopify_DE_" + variant.featured_image?.product_id + '_' + variant.id,
        'google_business_vertical': 'retail'
      }
    ]
  });
})

// document.addEventListener("DOMContentLoaded", function(){
//   var grid_msnry = document.querySelector('.masonry_wrapper');
//   // init with selector
//   var msnry = new Masonry('.masonry_wrapper', {
//     // options...
//     itemSelector: '.masonry_item',
//     horizontalOrder: true
//   });

//   if(window.innerWidth <= 590 && grid_msnry != null && document.querySelectorAll(".community_section_wrapper .masonry_item")[4] != null){
//     const hightItemOne = document.querySelectorAll(".community_section_wrapper .masonry_item")[0].getBoundingClientRect().height
//     const hightItemTwo = document.querySelectorAll(".community_section_wrapper .masonry_item")[1].getBoundingClientRect().height
//     const hightItemThree = document.querySelectorAll(".community_section_wrapper .masonry_item")[2].getBoundingClientRect().height
//     grid_msnry.style.maxHeight = hightItemOne + hightItemTwo + hightItemThree + 40 + "px";
//   }

//   var read_btns = document.querySelectorAll(".readBtns");
//   read_btns.forEach(btn => {
//     btn.addEventListener("click", function(){
//       let parent = btn.closest(".community_section");
//       if(btn.getAttribute("id") == "readMore"){
//         parent.classList.remove("read_more_active");
//         if(window.innerWidth <= 590 && grid_msnry != null && document.querySelectorAll(".community_section_wrapper .masonry_item")[4] != null){
//           grid_msnry.style.maxHeight = "unset";       
//         }
//       }else{
//         parent.classList.add("read_more_active");
//         parent.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
//         if(window.innerWidth <= 590 && grid_msnry != null && document.querySelectorAll(".community_section_wrapper .masonry_item")[4] != null){
//           grid_msnry.style.maxHeight = ((document.querySelectorAll(".community_section_wrapper .masonry_item")[4].getBoundingClientRect().top - document.querySelector(".community_section_wrapper").getBoundingClientRect().top) - document.querySelectorAll(".community_section_wrapper .masonry_item")[4].getBoundingClientRect().height - 120) + "px";
//         }
//       }
//     });  
//   });
// });

document.addEventListener("DOMContentLoaded", function(){
  // 1️⃣ Initialize Masonry for every section
  document.querySelectorAll('.masonry_wrapper').forEach(grid_msnry => {
    new Masonry(grid_msnry, {
      itemSelector: '.masonry_item',
      horizontalOrder: true
    });

    // 2️⃣ Handle mobile height logic for each section
    if(window.innerWidth <= 590){
      const items = grid_msnry.querySelectorAll(".masonry_item");
      if(items.length > 4){
        const h1 = items[0].getBoundingClientRect().height;
        const h2 = items[1].getBoundingClientRect().height;
        const h3 = items[2].getBoundingClientRect().height;
        grid_msnry.style.maxHeight = (h1 + h2 + h3 + 40) + "px";
      }
    }
  });

  // 3️⃣ Add click events for read buttons (work per section)
  document.querySelectorAll(".readBtns").forEach(btn => {
    btn.addEventListener("click", function(){
      let parentSection = btn.closest(".community_section");
      let grid_msnry = parentSection.querySelector('.masonry_wrapper');
      let items = parentSection.querySelectorAll(".masonry_item");

      if(btn.getAttribute("id") == "readMore"){
        parentSection.classList.remove("read_more_active");
        if(window.innerWidth <= 590 && items.length > 4){
          grid_msnry.style.maxHeight = "unset";       
        }
      } else {
        parentSection.classList.add("read_more_active");
        parentSection.scrollIntoView({ behavior: "smooth", block: "start" });
        if(window.innerWidth <= 590 && items.length > 4){
          const topWrapper = parentSection.querySelector(".community_section_wrapper").getBoundingClientRect().top;
          const itemTop = items[4].getBoundingClientRect().top;
          const itemHeight = items[4].getBoundingClientRect().height;
          grid_msnry.style.maxHeight = ((itemTop - topWrapper) - itemHeight - 120) + "px";
        }
      }
    });
  });
});


// handle reviews io
window.addEventListener('DOMContentLoaded', function(){
  ratingSnippet("ruk_rating_snippet", {
    store: "xbyx-ch",
    mode: "default",
    color: "#F3C200",
    linebreak: false,
    lang: "en",
    usePolaris: true,
    showEmptyStars: false,
  });
  var snippets = document.querySelectorAll(".ruk_rating_snippet");
  var reviewWidget = document.querySelector("reviewsio-product-reviews-widget");
  snippets.forEach(snippet => {
    snippet.onclick = function(e) {
      if(snippet.getAttribute("href")){
        e.preventDefault();
        window.location.href = snippet.getAttribute("href");
      } else if(reviewWidget && snippet){
        let scroll_by_value = reviewWidget.offsetTop - document.querySelector("#SiteHeader").offsetHeight - document.querySelector("#shopify-section-announcement").offsetHeight  - 60;
        window.scrollTo({ left: 0, top: scroll_by_value, behavior: "smooth"});
      }
    }
  });
  if(window.location.href.includes("#reviewsio_polaris")){
    if(reviewWidget) {
      let scroll_by_value = reviewWidget.offsetTop - document.querySelector("#SiteHeader").offsetHeight - document.querySelector("#shopify-section-announcement").offsetHeight  - 60;
      window.scrollTo({ left: 0, top: scroll_by_value, behavior: "smooth"});
    }
  }
});
document.addEventListener("variant:change", function() {
  ratingSnippet("ruk_rating_snippet", {
    store: "xbyx-ch",
    mode: "default",
    color: "#F3C200",
    linebreak: false,
    lang: "en",
    usePolaris: true,
    showEmptyStars: false,
  });
})

function removeItems(items,updatedItems,redirectToCheckout){
  let update = {};
  console.log("removeItems", items);
  items.forEach(num => {
    update[num] = 0;
    console.log("update item to zero", update, num);
  });
  updatedItems.forEach(update_num => {
    update[update_num] = 1;
  });

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    },
    body: JSON.stringify({
        updates: update
    })
  })
  .then(response => response.json())
  .then(function(response){
    document.dispatchEvent(new CustomEvent('cart:build'));
    console.log("cart after update");
    window.ignored_gift_popup = "false";
    if(redirectToCheckout){
      window.location.href = '/checkout';
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function recheckCartItems(redirectToCheckout) {
  let arrayItems = [];
  let updatedItems = [];
  let shakerProductID = window.gift?.giftProduct;
  let giftProductID = window.cart_gift?.product_id;
  console.log("shakerProductID ", shakerProductID);
  console.log("giftProductID ", giftProductID);
  let hideATC_items = document.querySelectorAll(".cart__item[data_ATC_item]");
  let hideATC_items_ids =[];
  hideATC_items.forEach(hideATC_item => {
    hideATC_items_ids.push(parseInt(hideATC_item.getAttribute("data_ATC_item")));
  });
  console.log("hideATC_item need to be only 1:", hideATC_items_ids);
  fetch("/cart.js")
  .then(response=> response.json())
  .then(response => {
    console.log("recheck items that need to be deleted from cart ", response.items);
    let found_gift_product = false;
    response.items.forEach( item => {
      console.log("item: ", item.title);
      // handle hide_ATC tagged items
      if(item.properties._cart_xsell && response.items.length == 1){
        console.log("remove item because of xsell and no other items in cart: ", item.properties._cart_xsell);
        arrayItems.push(item.id);
      }
      if (hideATC_items_ids.indexOf(item.id) !== -1 && item.quantity > 1) {
        console.log("hide_ATC ID exists in the array.");
        updatedItems.push(item.id);
      }
      // handle gift offer products
      if(item.properties._Offer_Gift ){
        if(response.items.length > 1){
          // console.log("check if linked offer product quantity is less than offer product quantity or not found");
          let offer_product_id = item.properties._Offer_Product;
          let offer_product_quantity = item.properties._Offer_Quantity;
          let linked_offer_product = response.items.find(item => item.id == offer_product_id && item.properties._Offer_Product == 'Yes');
          // console.log("linked_offer_product: ", linked_offer_product);
          if(linked_offer_product){
            // console.log("linked_offer_product: ", linked_offer_product.title);
            if(linked_offer_product.quantity < offer_product_quantity){
              console.log("remove offer gift item because linked offer product quantity is less than offer product quantity");
              arrayItems.push(item.id);
            }
          }else{
            console.log("remove offer gift item because linked offer product not found");
            arrayItems.push(item.id);
          }
        }else{
          if(response.items.length == 1){
            console.log("remove _Offer_Gift item because no other items in cart: ", item.properties._Offer_Gift);
            arrayItems.push(item.id);
          }
          else if(item.quantity > 1){
            console.log("update _Offer_Gift to be 1 only");
            updatedItems.push(item.id);
          }
        }
      }
      // handle bundle sets items
      if (item.properties["_bundle_set"] && !item.properties["_bundle_items"]){
        arrayItems.push(item.id);
      }
      // handle gift products
      if(giftProductID != null){
        if( item.product_id == giftProductID ){
          if( found_gift_product ){
            console.log("it's already found before so remove this variant");
            arrayItems.push(item.id);
          }else{
            if( item.quantity > 1){
              console.log("update gift to be 1 only");
              updatedItems.push(item.id);
            }
            found_gift_product = true;
          }
        }
      }
      // handle shaker products
      if(shakerProductID != null){
        if( item.id == shakerProductID && item.quantity > 1 ){
          console.log("update shaker to be 1 only");
          updatedItems.push(item.id);
        }
      }
    })
  })
  .then( () => {
    if(arrayItems || updatedItems) removeItems(arrayItems,updatedItems,redirectToCheckout);
  })
}

window.addEventListener('load', function(e){
    recheckCartItems(false);
    let checkoutbtns = document.querySelectorAll(".btn.cart__checkout_custom");
    if(checkoutbtns.length > 0){
      checkoutbtns.forEach(checkoutbtn => {
        checkoutbtn.addEventListener('click', function(e) {
          console.log("redirect to checkout");
          recheckCartItems(true);
        });
      });
    }
});

function addPDPToCart(btn){
  let variant = parseInt(btn.dataset.variantId);
  console.log("variant:",variant);
  let formItems =[
    {
      'id': variant,
      'quantity': 1
    }
  ];
  let formData = {
    'items': formItems
  };
  console.log("formData: ",formData);
  fetch(theme.routes.cartAdd, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(product => {
    if (product.status === 422){
      return;
    }
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: product,
        addToCartBtn: btn
      }
    }));

  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Handle shakerChoice A/B test
function handleShakerChoiceTest() {

  var shakerWrapper = document.querySelector("shakerChoiceWrapper");
  if (!shakerWrapper) return;  // Early return if no shaker wrapper exists

  var shakerBanner = document.querySelector("shakerChoiceBanner"),
      removeShakerBtn = shakerWrapper.querySelector("#removeShakerChoice");

  // Log shaker choice state for debugging
  console.log("Shaker choice state:", window.shaker_choice);

  // 1. Hide elements if user already removed them
  if (sessionStorage.getItem("shakerRemoved") === "true") {
    console.log("shaker choice removed by user shakerRemoved");
    window.shaker_choice = "false";
  }
  // Handle shaker choice state
  if (window.shaker_choice === "false" || window.shaker_removed === "true") {
    // Remove elements if shaker choice is disabled
    shakerWrapper.remove();
    if (shakerBanner) shakerBanner.remove();
  } 
  else {
    // Show shaker wrapper
    shakerWrapper.style.display = "flex";

    // Add remove shaker choice functionality
    if (removeShakerBtn) {
      removeShakerBtn.addEventListener("click", () => {
        console.log("Shaker choice removed by user");
        shakerWrapper.classList.add("hide_shaker_banner");
        if (shakerBanner) shakerBanner.classList.add("hide_shaker_banner");
        sessionStorage.setItem("shakerRemoved", "true");
      });
    }

    // Handle banner display and close functionality
    if (shakerBanner) {
      shakerBanner.style.display = "flex";
      let bannerCloseBtn = shakerBanner.querySelector("#shaker_banner_close");
      if (bannerCloseBtn) {
        bannerCloseBtn.addEventListener("click", () => {
          console.log("Shaker banner closed by user");
          shakerBanner.classList.add("hide_shaker_banner");
        });
      }
    }
  }
}

function handleBundleError(){
  if(document.querySelector("#bundleErrorAttribute") != null){
    theme.cart.updateAttribute("Bundle Error", "YES"); 
    // console.log("add bundle error");
  } else{
    theme.cart.updateAttribute("Bundle Error", ""); 
    // console.log("remove bundle error");
  }
}

async function addToCartWithOffer(formData){
  const response = await fetch(theme.routes.cartAdd, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(formData)
  });
  return await response.json();
}

function addOfferProductToCart(btn){
  let variant = parseInt(btn.dataset.variantId);
  // console.log("variant:",variant);
  let btn_quantity = 1;
  let formItems =[];
  if(btn.dataset.quantity != null && btn.dataset.quantity != ""){
    btn_quantity = parseInt(btn.dataset.quantity);
  }
  formItems.push({
    'id': variant,
    'quantity': btn_quantity,
    'properties': {
      '_Offer_Product': 'Yes',
      '_Offer_Price': btn.dataset.offerPrice,
      '_Offer_Quantity': btn.dataset.quantity
    }
  });
  // Add discount if exists
  if(btn.dataset.offerDiscount && btn.dataset.offerDiscount != ""){
    formItems[0].properties._offer_discount = btn.dataset.offerDiscount;
  }
  // console.log("btn.hasAttribute('data-gift-product'):",btn.hasAttribute("data-gift-product"));
  if(btn.hasAttribute("data-gift-product") && btn.getAttribute("data-gift-product") != ""){
    formItems[0].properties._Offer_gift_product = btn.getAttribute("data-gift-product");
    formItems.push({
    'id': parseInt(btn.getAttribute("data-gift-product")),
      'quantity': 1,
      'properties': {
        '_offer_discount': '100',
        '_Offer_Gift': 'Yes',
        '_Offer_Product': btn.dataset.variantId,
        '_Offer_Quantity': btn.dataset.quantity
      }
    });
  }
  let formData = {
    'items': formItems
  };
  // console.log("formData: ",formData);
  // Step 1: Clear the cart using the clear endpoint
  fetch('/cart/clear.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(() => {
    // Step 2: Add new items to cart
    return addToCartWithOffer(formData);
  })
  .then(product => {
    if (product.status === 422){
      console.error('Error adding to cart:', product);
      return;
    }
    //load cart
    // document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
    //   detail: {
    //     product: product,
    //     addToCartBtn: btn
    //   }
    // }));

    // Step 3: Redirect to checkout
    window.location.href = '/checkout';
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

document.addEventListener('cart:final_update', function(e){
  console.log("cart:final_update");
  handleShakerChoiceTest();
  handleBundleError();
});

window.addEventListener('load', function(e){
  console.log("shakerchoice",document.querySelector("shakerChoiceWrapper"));
  if(document.querySelector("shakerChoiceWrapper") != null){
    handleShakerChoiceTest();   
  }
  handleXsellProduct();
});

function handleXsellProduct(){
  if(window.xSellProductABTest == "false"){
    let xSellWrapperAbTest = document.querySelector('.x-sell__wrapper.xsell-product-ab');
    if(xSellWrapperAbTest){
      xSellWrapperAbTest.remove();
      window.xSellProduct = window.xSellProduct;
    }
  }
  if(window.xSellProductABTest == "true"){
    let xSellWrapperOriginal = document.querySelector('.x-sell__wrapper.xsell-product-original');
    if(xSellWrapperOriginal){
      xSellWrapperOriginal.remove();
      window.xSellProduct = window.xSellProductAb;
    }
  }
}

// adjust dropdown closing
document.addEventListener('click', function(event) {
  const dropdowns = document.querySelectorAll('details.sort-items__button--popup[open]');
  dropdowns.forEach((dropdown) => {
    if (dropdown.hasAttribute('open') && !dropdown.contains(event.target)) {
      console.log("close opened dropdown", dropdown);
      dropdown.removeAttribute('open');
    }
  });
});

// open cart drawer if ?open_cart=true
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('open_cart') === 'true') {
    // Clean up the URL so ?open_cart=true disappears
    const newUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);

    // Find the cart drawer link and simulate a click
    const cartLink = document.querySelector('a.js-drawer-open-cart');
    if (cartLink) {
      cartLink.click();
    } else {
      console.warn("Cart drawer link not found");
    }
  }
});
